//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const objectActionOptions = [
  { label: '查询', value: 'select' },
  { label: '新增', value: 'insert' },
  { label: '更新', value: 'update' },
  { label: '删除', value: 'delete' },
];
export default {
  props: {
    show: { type: Boolean, default: false },
    objectInfo: { type: Object, default: () => {} },
  },
  data() {
    return {
      objectActionOptions,
      info: [],
    };
  },
  computed: {
    visible: {
      get() {
        if (this.show) {
          this.getObjectRoleInfo();
        }
        return this.show;
      },
      set(val) {
        this.$emit('cancel', val);
      },
    },
  },
  methods: {
    async getObjectRoleInfo() {
      this.info = [];
      try {
        const { data } = await this.$request({
          url: this.$api.getObjectRolePermission,
          data: {
            appid: this.objectInfo.appid,
            code: this.objectInfo.code,
          },
        });
        this.info = data;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
